export const DEFAULT_EXPORT_FIELDS = [
  'Album',
  'Artist',
  'BPM',
  'Comment',
  'Composer',
  'External Id',
  'Genre',
  'Grouping',
  'ISRC',
  'ISWC',
  'Lyrics',
  'ProNumber',
  'Release Date',
  'Title',
  'TrackNumber',
  'Year',
]
